import { render, staticRenderFns } from "./device-infos-updated.vue?vue&type=template&id=71b6b0ce&scoped=true"
import script from "./device-infos-updated.vue?vue&type=script&lang=js"
export * from "./device-infos-updated.vue?vue&type=script&lang=js"
import style0 from "./device-infos-updated.vue?vue&type=style&index=0&id=71b6b0ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b6b0ce",
  null
  
)

export default component.exports